import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import styled from 'styled-components'
import { approveCgu, getCgu } from '../../services'
import theme from '../../../common/theme'
import PimpPageHeader from '../../components/PimpPageHeader'
import Actions from '../../../common/Actions'
import Checkbox from '../../../common/Checkbox'

const CguContainer = styled.div`
  display: flex;
  flex-direction: column;
  
  .consent-checkbox {
    margin: 40px 20px 40px 0px;
  }
  
  .cgu-content {
    margin-left: 20px;
    margin-right: 20px;
    
      > h2 {
      margin-top: 30px;
      margin-right: 20px;
      font-weight: bold;
      color: ${ theme.palette.blue };
      font-size: 20px;
      line-height: 23px;
    }
  }
  
`


function CguPage({ ...props }) {
  const history = useHistory()

  const [cgu, setCgu] = useState(null)
  const [canSubmit, setCanSubmit] = useState(false)

  const consentMsg = 'Je certifie avoir lu et accepté les Conditions Générales d\'Utilisation.'

  useEffect(() => {
    const getContent = async () => {
      const result = await getCgu()
      setCgu(result.content)
    }
    getContent()
  }, [])

  const logout = () => {
    history.push('/logout')
    return true
  }

  const approve = async () => {
    await approveCgu()
    history.push('/')
    return true
  }

  return <CguContainer>
    <PimpPageHeader />

    <div className="cgu-content" dangerouslySetInnerHTML={ { __html: cgu } }/>

    <Checkbox checked={ canSubmit}
              onChange={ value => setCanSubmit(value) }
              position="right"
              className="consent-checkbox">
      { consentMsg }
    </Checkbox>

    <Actions submitTxt='Je valide' onSubmit={ approve }
        cancelTxt='Se déconnecter' onCancel={ logout }
        disableSubmit={ !canSubmit }
    />
  </CguContainer>
}

export default CguPage
